
// import Try from '~/helpers/tryCatch.js';
import gql from 'graphql-tag'
import userFavProductTermCI from '@/apollo/queries/user/userFavProductTermCI'
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment'
import termCITooltips from '~/apollo/queries/product/tooltips/termCITooltips'
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  name: "FavProductTermCICard",
  mixins: [productPromotionMixins, productInsuranceNameMixins],
  data: () => ({
    product: Object,
    productLoading: 0,
    currentLink: "",
  }),
  props: {
    productId: String,
    favProductId: String,
  },
  apollo: {
    product: {
      prefetch: true,
      loadingKey: "productLoading",
      query: gql`${userFavProductTermCI} ${productPromotionFragment}`,
      variables() {
        const returnObj = {};

        returnObj.id = this.productId;
        returnObj.locale = this.$normalizeLocale(this.$i18n.locale);

        console.debug(returnObj);

        return returnObj;
      },
      update(data) {
        // return this.$normalizeStrapi(data?.termCiPlanScenarios?.data);
        return data?.termCiPlanScenarios?.data;
      },
      result({ data }) {
        // console.debug("***apollo termCiPlanScenarios data ***");
        // console.debug(JSON.stringify(data));
      },
    },
    tooltips: {
      query: termCITooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data).TermCI;
      },
    },
  },
  computed: {
    simpleItem() {
      if (!this.productLoading) {
        if (this.product) {
          return this.product.map((item) => {
            let promotionPrices = Object;
            promotionPrices = {};
            let discountedTenYearAvgPremium = null;
            const planName = item.attributes.term_ci_plan.data.attributes.term_ci_plan_translations.data[0].attributes.name;
            const insurer = item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;  
            const link = this.currentLink;
            let promotions = null;
            let promotion = null;
            let promotion_last_call = null;

            let decoderCTALink = this.$generateWhatsappCTALink(this.$t('products.termci.tci_categoryName'), insurer, planName, { page: this.$route.name?.split('__')[0], link: link });
            let decoderCTAText = '';

            // check scenario level promo first , then plan level promotion 
            if (item.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.product_promotions.data;
            }
            if (item.attributes.term_ci_plan.data.attributes.product_promotions.data?.length > 0) {
              promotions = item.attributes.term_ci_plan.data.attributes.product_promotions.data;
            }
            
            if(promotions != null) {
              promotion = this.checkPromotionValid(promotions);
              promotion_last_call = this.checkPromotionLastCall(promotion);

              if (!promotion) {
                promotion = null;
              }
              else {
                if (promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink) {
                  decoderCTALink = promotion.attributes?.product_promotion_translations?.data[0]?.attributes?.DecoderCTALink;
                  decoderCTAText = this.$t('products.product_website');
                }
                const discounts = promotion.attributes.DiscountPercentage;
                if (discounts) {
                  // calculate promotion price and avg premium
                  let originalPrices = Array;
                  originalPrices = [];
                  for (let i = 0; i < 10; i++) {
                    originalPrices[i] = item.attributes['premium_display_' + parseInt(i + 1)];
                  }
                  const calulatedValue = this.calculateDiscountedPremium(originalPrices, discounts);

                  promotionPrices = calulatedValue.promotionPrices;
                  discountedTenYearAvgPremium = calulatedValue.discountedTenYearAvgPremium;

                  if (discountedTenYearAvgPremium === parseInt(item.attributes.ten_year_average_premium.toFixed(0))) {
                    discountedTenYearAvgPremium = null;
                  }
                }
              }
            }

            const filteredTranslations = this.getFilteredTranslations(item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
            .insurance_company_translations.data[0].attributes.localizations.data);

            return {
              currency: item.attributes.currency.data.attributes.code,
              scenario_code: item.attributes.scenario_code,
              sum_assured: item.attributes.sum_assured,
              age: item.attributes.age,
              cancer_score: item.attributes.cancer_score,
              heart_score: item.attributes.heart_score,
              stroke_score: item.attributes.stroke_score,
              other_ci_score: item.attributes.other_ci_score,
              general_term_score: item.attributes.general_term_score,
              rating: item.attributes.rating,
              renewal_term: item.attributes.renewal_term,
              first_year_premium: item.attributes.first_year_premium,
              ten_year_average_premium: item.attributes.ten_year_average_premium,

              overall_star: item.attributes.term_ci_plan.data.attributes.overall_star,

              // plan
              plan_name: item.attributes.term_ci_plan.data.attributes.term_ci_plan_translations.data[0].attributes.name,
              underwriting_text: item.attributes.term_ci_plan.data.attributes.term_ci_plan_translations.data[0].attributes.underwriting_text,
              ci_type: item.attributes.term_ci_plan.data.attributes.term_ci_plan_translations.data[0].attributes.ci_type,

              // insurer
              insurer_name_first: item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name,
              insurer_name_second: filteredTranslations[0].attributes.name,
              insurer_logo: item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.logo,
              insurer_code: item.attributes.term_ci_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.code,


              product_promotion: promotion,
              promotion_prices: promotionPrices,
              promotion_last_call: promotion_last_call,

              discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
              decoder_cta_link: decoderCTALink,
              decoder_cta_text: decoderCTAText,
              scenarioId: item.id,
            };
          })[0];
        }
      }
      return null;
    },
    displayProduct() {
      if (this.simpleItem) {
        return {
          favProductId: this.favProductId,
          scenarioId: this.simpleItem.scenarioID,
          id: this.simpleItem.scenario_code,
          productType: "term-critical-illness",
          showFiveStarBadge: this.$formatShowFiveStarBadge(this.simpleItem.overall_star),
          showTrending: false,

          productLink: this.$extendPath('/products/term-critical-illness', '/' + this.simpleItem.scenario_code),
          productName: this.simpleItem.plan_name,
          insuranceCompany: {
            name: this.simpleItem.insurer_name_first + ' | ' + this.simpleItem.insurer_name_second,
            code: this.simpleItem.insurer_code,
            logoSrc: this.simpleItem.insurer_logo?.data?.attributes.url,
            logoAlt: this.simpleItem.insurer_name_first,
          },
          userRating: {
            score: this.simpleItem.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.getScore(this.simpleItem)),
            description: this.$t('products.termci.tci_termCIScore'),
            toolTipHtml: this.getTooltipContentByKey('tci_termCIScore'),
          },
          features: [
            {
              text: this.getRenewal(this.$t('products.renewalUnit'), this.simpleItem.renewal_term),
              type: 'renewal_term',
            },
            {
              text: this.simpleItem.ci_type,
              type: 'multiple_claims',
            },
            {
              text: this.simpleItem.underwriting_text,
              type: 'underwriting',
            },
          ],
          keyItems: [
            {
              value: this.getCoverageText(this.simpleItem.cancer_score, this.simpleItem.heart_score, this.simpleItem.stroke_score, this.simpleItem.other_ci_score),
              key: this.$t('products.termci.tci_cICoverage'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
              mode: 'long-text',
            },
            {
              value: this.simpleItem.discounted_ten_year_avg_premium ? this.$formatPrice(this.simpleItem.discounted_ten_year_avg_premium) : this.$formatPrice(this.simpleItem.ten_year_average_premium),
              key: this.$t('products.termci.tci_10yearAvgPremium'),
              topSubText: this.simpleItem.currency,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: this.simpleItem.discounted_ten_year_avg_premium ? this.$formatPrice(this.simpleItem.ten_year_average_premium) : '',
            },
          ],
          compactKeyItems: [
            {
              value: this.simpleItem.promotion_prices[0] ? this.$formatPrice(this.simpleItem.promotion_prices[0]) : this.$formatPrice(this.simpleItem.first_year_premium),
              key: this.$t('products.termci.tci_firstYearPremium'),
              topSubText: this.simpleItem.currency,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: this.simpleItem.promotion_prices[0] ? this.$formatPrice(this.simpleItem.first_year_premium) : '',
            },
            {
              value: this.getCoverageText(
                this.simpleItem.cancer_score,
                this.simpleItem.heart_score,
                this.simpleItem.stroke_score,
                this.simpleItem.other_ci_score,
                'compact'
              ),
              key: this.$t('products.termci.tci_cICoverage'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
              mode: 'long-text',
            },
          ],
          mobileKeyItems: [
            {
              value: this.getCoverageText(
                this.simpleItem.cancer_score,
                this.simpleItem.heart_score,
                this.simpleItem.stroke_score,
                this.simpleItem.other_ci_score,
                'mobile'
              ),
              key: this.$t('products.termci.tci_cICoverage'),
              topSubText: '',
              toolTipHtml: '',
              symbolValue: '',
              originalValue: '',
              mode: 'long-text',
            },
            {
              value: this.simpleItem.discounted_ten_year_avg_premium
                ? this.$formatPrice(this.simpleItem.discounted_ten_year_avg_premium)
                : this.$formatPrice(this.simpleItem.ten_year_average_premium),
              key: this.$t('products.termci.tci_10yearAvgPremium'),
              topSubText: this.simpleItem.currency,
              toolTipHtml: '',
              symbolValue: '',
              originalValue: this.simpleItem.discounted_ten_year_avg_premium ? this.$formatPrice(this.simpleItem.ten_year_average_premium) : '',
            },
          ],
          promotion: {
            category: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionCategory,
            title: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.PromotionTitle,
            ctaButtonLink: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink,
            ctaButtonText: this.simpleItem.product_promotion?.attributes?.product_promotion_translations?.data[0]?.attributes?.CTAButtonText,
            promotionId: this.simpleItem.product_promotion?.id,
            scenarioId: this.simpleItem.scenarioID,
            lastCall: this.simpleItem.promotion_last_call

          },
          mainButtonCTA: {
            text: this.simpleItem.decoder_cta_text,
            link: this.simpleItem.decoder_cta_link,
          },
          price: {
            originalPrice: this.simpleItem.promotion_prices[0] ? this.$formatPrice(this.simpleItem.first_year_premium) : '',
            discountPrice: this.simpleItem.promotion_prices[0] ? this.$formatPrice(this.simpleItem.promotion_prices[0]) : this.$formatPrice(this.simpleItem.first_year_premium),
            prefix: this.simpleItem.currency,
            postfix: '',
            subText: this.$t('products.termci.tci_firstYearPremium'),
            toolTipHtml: '',
          },
        }
      }
      return null
    },
  },
  watch: {
    product() {
      if (this.product.length) {
        this.$emit("product-load", 'TCi');
      } else {
        try {
          throw new Error("*** Product not found ***");
        } catch (e) {
          console.error(e.name + ": " + e.message);
          this.$sentry.captureException(e);
        }
      }
    },
  },
  mounted() {
    this.currentLink = window.location.href;
  },
  updated() {
    if (this.simpleItem) {
      this.$emit("productTitle", { id: this.favProductId, companyName: this.simpleItem.insurer_name_first, title: this.simpleItem.plan_name });
    }
  },
  methods: {
    getScore(product) {
      return product.rating.toFixed(1);
    },

    getRenewal(label, renewalTerm) {
      if (renewalTerm === 1) {
        return this.$t('products.annualRenewal');
      }
      return label.replace("$num", renewalTerm);
    },

    getCoverageText(cancerScore, heartScore, strokeScore, otherCIScore, mode = 'list') {
      const renderText = (score, text) => {
        const resultText = score <= 0 ? '<span style="color:#C9C1C1;">' + text + '</span>' : text;
        let spanStyle = '';

        switch (mode) {
          case 'compact':
            spanStyle = '<span style="display: inline-block; margin-right: 10px; margin-bottom: 7px;">';
            break;

          case 'mobile':
            spanStyle = '<span style="display: inline-block; margin-left: 10px;">';
            break;

          default:
            spanStyle = '<span style="display: inline-block; margin-right: 18px;">';
            break;
        }
        return spanStyle + resultText + '</span>';
      };
      const resultCancer = renderText(cancerScore, this.$t('products.termci.tci_cancer'));
      const resultHeart = renderText(heartScore, this.$t('products.termci.tci_heart'));
      const resultStroke = renderText(strokeScore, this.$t('products.termci.tci_stroke'));
      const resultOthers = renderText(otherCIScore, this.$t('products.termci.tci_otherCriticalIllness'));
      return resultCancer + resultHeart + resultStroke + resultOthers;
    },

    getTooltipContentByKey(mKey) {
      return this.tooltips?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    unfavourite() {
      this.product = null;
    },
  },
}
